// TODO: add the Frame component to the image when it's available

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-biography-full',
  styleUrl: 'biography.css',
  shadow: true,
})
export class Biography {
  @Prop() src: string;
  @Prop() alt: string;
  @Prop() nameandcredentials: string;
  @Prop() phonenumber: string;
  @Prop() email: string;
  @Prop() faxnumber: string;
  @Prop() officelocationshow: boolean;

  render() {
    if (this.src && !this.alt) console.warn(`Biography image is missing alt text.`)
    const photoShow = this.src ? <div class="bio-image-container-aside">{this.src && <img src={this.src} alt={this.alt} class="image-bio-full" />}</div> : <div></div>; 
    const emailShow = this.email ? <p class="bio-email-aside"><div class="email-label bio-aside-label">Email: </div><div class="fax-num-full bio-aside-value"><a href={`mailto:${this.email}`}>{this.email}</a></div></p> : <div></div>;
    const phoneShow = this.phonenumber ? <p><div class="phone-label bio-aside-label">Phone: </div><div class="fax-num-full bio-aside-value"><a href={`telephone:${this.phonenumber}`}>{this.phonenumber}</a></div></p> : <div></div>;
    const faxShow = this.faxnumber ? <p><div class="fax-num-label bio-aside-label">Fax Number: </div><div class="fax-num-full">{this.faxnumber}</div></p> : <div></div>;
    const addressShow = this.officelocationshow ? <p><div class="fax-num-label bio-aside-label">Office Location: </div><div class="fax-num-full bio-aside-value"><slot name="officeaddress" /></div></p> : <div></div>;
    return (
      <div class="bio-full">
        <div class="bio-full-name">
          <h1>{this.nameandcredentials}</h1>
        </div>
        <div class="bio-aside">
          {photoShow}
          <div class="bio-aside-info">
            {emailShow}
            {phoneShow}
            {faxShow}
            {addressShow}
          </div>
        </div>
        <div class="bio-full-body">
          <slot name="biobodyinfo"/>
        </div>
      </div>
    );
  }
}
